// theme/components/drawer.js
export default {
    parts: ['header', 'headerText', 'body', 'footer', 'closeButton', 'dialog', 'backButton'],
    baseStyle: {
        header: {
            paddingTop: 1,
            paddingRight: {base: 4, lg: 8},
            paddingBottom: 1,
            paddingLeft: {base: 4, lg: 8},
            boxShadow: 'base'
        },
        body: {
            paddingTop: {base: 4, lg: 6},
            paddingRight: {base: 4, lg: 6},
            paddingBottom: {base: 4, lg: 6},
            paddingLeft: {base: 4, lg: 6}
        },
        footer: {
            paddingTop: 6,
            paddingRight: {base: 4, lg: 6},
            paddingBottom: 11,
            paddingLeft: {base: 4, lg: 6}
        }
    },
    variants: {
        filterDrawer: {
            header: {
                pt: '20px',
                pb: '20px',
                pr: {base: 4, lg: 8},
                pl: {base: 4, lg: 8},
                boxShadow: 'none',
                borderBottom: '1px solid',
                borderColor: ' gray.50'
            },
            body: {
                padding: 0
            }
        },
        menuDrawer: {
            body: {
                padding: '0 0 40px 0'
            }
        },
        searchModal: {
            body: {
                padding: 0,
                paddingTop: 0,
                paddingRight: 0,
                paddingBottom: 0,
                paddingLeft: 0
            }
        },
        webDrawer: {
            header: {
                display: 'flex',
                alignItems: 'center',
                paddingTop: 4,
                paddingBottom: 4,
                pr: {base: 4, lg: 4},
                pl: {base: 4, lg: 4},
                boxShadow: 'unset',
                borderBottom: '1px solid',
                borderColor: 'webTheme.strokeTertiary'
            },
            body: {
                paddingTop: {base: 6, lg: 6},
                paddingRight: {base: 4, lg: 4},
                paddingBottom: {base: 6, lg: 6},
                paddingLeft: {base: 4, lg: 4}
            },
            headerText: {
                display: 'block',
                textStyle: 'webH3',
                mb: 0
            },
            closeButton: {
                position: 'absolute',
                top: 'auto',
                right: '16px',
                w: '24px',
                h: '24px',
                minW: 'auto',
                minH: 'auto'
            },
            dialog: {
                height: {base: '75vh', lg: '100%'},
                maxW: {lg: '448px'}
            },
            footer: {
                paddingTop: 4,
                paddingRight: 4,
                paddingBottom: 4,
                paddingLeft: 4,
                borderTop: '1px solid',
                borderColor: 'webTheme.strokeTertiary'
            },
            backButton: {
                w: 'auto',
                h: 'auto',
                minW: 'auto',
                minH: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 2
            }
        }
    }
}
